import L from 'leaflet';

const setupLeafletMap = () => {
    const map = L.map('map', {
        zoomControl: false,
        minZoom: 2.1,
        maxBounds: [
            [-85, -180],
            [85, 180]
        ],
        maxBoundsViscosity: 1.0,
        crs: L.CRS.EPSG3857
    }).setView([46.5, 21.0], 6); //Focus on Danube region

    L.Polyline = L.Polyline.include({
        getDistance: function (system) {
            var mDistanse = 0,
                length = this._latlngs.length;
            for (var i = 1; i < length; i++) {
                mDistanse += this._latlngs[i].distanceTo(this._latlngs[i - 1]);
            }
            if (system === 'imperial') { // Changes from miles to kilometers.
                return mDistanse / 1609.34;
            } else {
                return mDistanse / 1000;
            }
        }
    });

    L.control.zoom({ position: 'bottomright' }).addTo(map);
    L.control.scale({ position: 'bottomright' }).addTo(map);
    var geocoder = L.Control.Geocoder.nominatim(); // Initializes the Geocoder (Search bar on the bottom left).

    // Add the geocoder control to the map
    L.Control.geocoder({
        geocoder: geocoder,
        placeholder: 'Search for a location...',
        defaultMarkGeocode: false
    }).on('markgeocode', function (e) {
        var center = e.geocode.center;

        // Set the view to the selected location
        map.setView(center, 13);

    }).addTo(map).setPosition('bottomleft');

    // Show coordinates
    map.on('mousemove', function (e) {
        const lat = e.latlng.lat.toFixed(4);
        const lng = e.latlng.lng.toFixed(4);
        document.getElementById('coordinates').innerHTML = `Lat: ${lat}, Lng: ${lng}`;
    });

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    return map;
}

export default setupLeafletMap;